import { type Mode } from 'core/domain/Mode'
import { type Stop } from 'core/domain/Stop'
import { type TruckType } from 'core/domain/Truck'

export type DerivedShipmentStatus = 'upcoming' | 'ongoing' | 'past' | 'archived'

export function isDerivedShipmentStatus(status: string): status is DerivedShipmentStatus {
  return ['upcoming', 'ongoing', 'past', 'archived'].includes(status)
}

/**
 * Pre-`ENABLE_CARRIER_ARCHIVED_SHIPMENTS` behavior: Past also returns archived shipments.
 * Remove with the flag.
 */
export function withArchivedUnderPast(
  status?: Array<DerivedShipmentStatus>
): Array<DerivedShipmentStatus> | undefined {
  return status?.includes('past') ? [...status, 'archived'] : status
}

export type AgnosticShipmentFilter = {
  pickup?: Stop
  delivery?: Stop
  /** Should have the format `yyyy-MM-dd` */
  pickupDateAfter?: string
  /** Should have the format `yyyy-MM-dd` */
  pickupDateBefore?: string
  status?: Array<DerivedShipmentStatus>
  shipper?: Array<number>
  mode?: Array<Mode>
  equipment?: Array<TruckType>
  tags?: Array<string>
  bol?: string
  po?: string
  reference?: string
  so?: string
  search?: string
  pendingAppointments?: boolean
  missingPods?: boolean
  missingInvoices?: boolean
  unreadChat?: boolean
}
